import React, { useState } from "react";

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const navLinks = [
    { href: "#home", label: "Home" },
    { href: "#about", label: "About" },
    { href: "#products", label: "Products" },
    { href: "#gallery", label: "Gallery" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <nav
      className="navbar navbar-expand-lg sticky-top navbar-dark"
      style={{
        backgroundColor: "#1a3e3f",
        padding: "8px 0",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        borderBottom: "3px solid #b68b40",
      }}
    >
      <div className="container">
        {/* Logo dan Nama Perusahaan */}
        <a className="navbar-brand" href="#home" style={{ padding: "0" }}>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {/* Logo Image */}
            <div
              style={{
                width: "45px",
                height: "45px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {!logoError ? (
                <img
                  src="/logoCAI.svg"
                  alt="PT Citra Aroma Indo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  onError={() => setLogoError(true)}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#b68b40",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#1a3e3f",
                  }}
                >
                  PT CITRA AROMA INDO
                </div>
              )}
            </div>

            {/* Nama Perusahaan */}
            <div className="d-none d-sm-block">
              <span
                style={{
                  color: "#e8d5b5",
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  letterSpacing: "1px",
                  lineHeight: "1.2",
                }}
              >
                PT CITRA{" "}
              </span>
              <span
                style={{
                  color: "#b68b40",
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  letterSpacing: "1px",
                  lineHeight: "1.2",
                }}
              >
                AROMA INDO
              </span>
            </div>

            {/* Inisial untuk Mobile */}
            <div className="d-sm-none">
              <span
                style={{
                  color: "#e8d5b5",
                  fontSize: "1.1rem",
                  fontWeight: "700",
                }}
              >
                PT CITRA AROMA INDO
              </span>
            </div>
          </div>
        </a>

        {/* Toggle Button Mobile */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsNavOpen(!isNavOpen)}
          style={{
            borderColor: "#e8d5b5",
            padding: "8px 12px",
          }}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Links */}
        <div
          className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
          style={{
            backgroundColor: isNavOpen ? "#1a3e3f" : "transparent",
            borderRadius: "10px",
            padding: isNavOpen ? "15px" : "0",
            marginTop: isNavOpen ? "15px" : "0",
          }}
        >
          <ul className="navbar-nav ms-auto align-items-lg-center">
            {navLinks.map((link, index) => (
              <li className="nav-item" key={index}>
                <a
                  className="nav-link"
                  href={link.href}
                  style={{
                    color: "white",
                    padding: "8px 16px",
                    fontWeight: "500",
                    fontSize: "1rem",
                    textAlign: "center",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#b68b40";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "white";
                  }}
                  onClick={() => setIsNavOpen(false)}
                >
                  {link.label}
                </a>
              </li>
            ))}

            {/* CTA Button */}
            <li className="nav-item">
              <a
                href="#contact"
                className="btn"
                style={{
                  backgroundColor: "#b68b40",
                  color: "white",
                  padding: "8px 25px",
                  borderRadius: "30px",
                  fontWeight: "600",
                  fontSize: "1rem",
                  border: "2px solid #b68b40",
                  marginLeft: "10px",
                  transition: "all 0.3s ease",
                  display: "inline-block",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#b68b40";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#b68b40";
                  e.target.style.color = "white";
                }}
                onClick={() => setIsNavOpen(false)}
              >
                Request Sample
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
